import { connect } from 'react-redux';
import { ApplicationState } from "../../../store";
import { ToxnotComponentProperties } from "../BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from '../BaseApplicationComponents/ToxnotSignInRequiredComponent';
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { InventoryQuestionnaireType, SurveyResponseState } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates';
import {
    Questionnaire,
    QuestionnairePageType,
    QuestionnaireQuestion,
    SurveyPageType,
    SupplierQuestionnaireData, QuestionType
} from '../../../store/Models/Surveys/SurveyDataModel';
import GroupMaterials from '../GroupMaterials';
import ProductOverview from '../ProductOverview';
import BomEditor from '../BomEditor';
import BatchResponse from '../BulkInputs/BulkInputs';
import SurveyResponseInstructions from '../../Survey/SurveyResponse/SurveyResponseInstructions';
import { InventoryDetailsResponse, PlausibilityData } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import SaveDataManager from '../../../utilities/SaveDataManager';
import { Result, ToxnotServiceClient } from '../../../store/ToxnotServiceClient';
import { TeamRole } from '../../../store/Models/UserContext';
import { FileTableEntry } from '../../../store/Models/Documents/DocumentModels';
import QuestionnairePage from '../QuestionnairePage';
import AddMaterials from "../AddMaterials";
import { RegulationManager } from '../../../store/Managers/RegulationManager'

import './style.css';
import Question from '../Question';

type SurveyPageProps =
    ToxnotComponentProperties &
    typeof SurveyResponseController.actionCreators &
    SurveyResponseState;

class SurveyPage extends ToxnotSignInRequiredComponent<SurveyPageProps> {
    public _serviceClient: ToxnotServiceClient;
    private readonly _inventoryQuestionnaireSaveDataManager: SaveDataManager<InventoryDetailsResponse>;
    private readonly _supplierQuestionnaireSaveDataManager: SaveDataManager<Questionnaire>;
    private readonly baseQuestionnaire = 'BaseQuestionnaire';

    public constructor(props: SurveyPageProps) {
        super(props);

        this._serviceClient = new ToxnotServiceClient();
        this._inventoryQuestionnaireSaveDataManager = new SaveDataManager(this.saveInventoryQuestionnaire, this.props.appServices);
        this._supplierQuestionnaireSaveDataManager = new SaveDataManager(this.saveSupplierQuestionnaire, this.props.appServices);
    }

    protected renderConcreteComponent() {
        const supplierLevelQuestionnaire = SurveyResponseController.getSupplierLevelQuestionnaire();

        switch (this.props.navContext.mainNavIndex) {
            case SurveyPageType.Instructions:
               return <SurveyResponseInstructions />;
            case SurveyPageType.GroupInventories:
                return <GroupMaterials />;
            case SurveyPageType.Batch:
                return <BatchResponse />
            case SurveyPageType.SupplierQuestionnaire:
                const supplierQuestionnairePageProps = {
                    onResponseChange: this.onResponseChange,
                    questionsList: supplierLevelQuestionnaire?.questionnaire?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.questions,
                    pageTitle: supplierLevelQuestionnaire?.questionnaire?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.languageToTitleMap[this.props.insActiveLanguage] ?? supplierLevelQuestionnaire?.questionnaire?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.title ?? '',
                    regulationId: supplierLevelQuestionnaire?.questionnaire?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.regulationId,
                    fileList: this.props.coreData?.allSupplierFiles,
                    inventoryId: this.props.selectedInventory?.inventoryId,
                    questionsRevisionInstructions: supplierLevelQuestionnaire?.revisionRequest?.supplierQuestionRevisions,
                    pageRevisionInstructions: supplierLevelQuestionnaire?.revisionRequest?.generalRevisionInstructions,
                    onComponentDidMount: async () => this.props.updateSupplierQuestionnairePageVisited(this.props.navContext.surveyQuestionnairePageIndex)
                }

                return <QuestionnairePage
                    key={this.props.navContext.surveyQuestionnairePageIndex}
                    {...supplierQuestionnairePageProps}
                />

            case SurveyPageType.Inventory:
                if (this.props.navContext.surveyQuestionnairePageIndex === -1) {
                    return <ProductOverview />;
                }

                const files = this.props.selectedInventory?.fileList ?? [];

                // TODO: this doesn't do anything?
                files.map(f => f.inventoryId = this.props.selectedInventory?.inventoryId);

                const questionnairePageProps = {
                    onResponseChange: this.onResponseChange,
                    questionsList: this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex].questions,
                    questionRegulatoryData: this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex].questionRegulatoryData,
                    pageTitle: this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex].languageToTitleMap[this.props.insActiveLanguage] ?? this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex].title,
                    regulationId: this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.regulationId ?? "",
                    fileList: files,
                    inventoryId: this.props.selectedInventory?.inventoryId,
                    questionsRevisionInstructions: this.getQuestionnaireRevisionInstructions(),
                    pageRevisionInstructions: this.getPageRevisionInstructions(),
                    questionnairePageType: this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex].type,
                    onComponentDidMount: async () =>
                        this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] === InventoryQuestionnaireType.BaseQuestionnaire ?
                            await this.props.updateBaseQuestionnairePageHasBeenVisited(this.props.navContext.surveyQuestionnaireIndex, this.props.navContext.surveyQuestionnairePageIndex, this.props.navContext.selectedInventoryPageIndex, true) :
                            await this.props.updateSelectSubInventoryCustomQuestionniarePageVisited(this.props.navContext.surveyQuestionnaireIndex, this.props.navContext.surveyQuestionnairePageIndex)
                };

                return <QuestionnairePage
                    key={this.props.navContext.surveyQuestionnaireIndex + "-" + this.props.navContext.surveyQuestionnairePageIndex}
                    {...questionnairePageProps}
                />;

            case SurveyPageType.Bom:
                const bomPageProps = {
                    pageRevisionInstructions: this.getPageRevisionInstructions()
                };

                return <BomEditor {...bomPageProps} />;
            case SurveyPageType.AddMaterials:
                return <AddMaterials/>;
            default:
                return null;
        }
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    public async componentDidMount() {
        this._inventoryQuestionnaireSaveDataManager.enable();
        this._supplierQuestionnaireSaveDataManager.enable();
    }

    private responseChangedHandleNavigation(
        question: QuestionnaireQuestion | undefined | null,
        supplierLevelQuestionnaire: SupplierQuestionnaireData | undefined | null,
        value: string
    ) {
        const isSupplierQuestionnaire = this.props.navContext.mainNavIndex === SurveyPageType.SupplierQuestionnaire &&
            supplierLevelQuestionnaire !== null
            && supplierLevelQuestionnaire !== undefined;

        if (question?.nextPageIndexMap && value !== question?.value) {
            const nextJumpKey = value.split(":")[0];
            const nextJumpIndex = question.nextPageIndexMap[nextJumpKey];

            if (nextJumpIndex && nextJumpIndex !== this.props.navContext.surveyQuestionnairePageIndex) {
                let previousPageStack = [...this.props.navContext.previousPageStack];

                previousPageStack.push(this.props.navContext.surveyQuestionnairePageIndex);
                const mainInventoryList = SurveyResponseController.getMainSupplierFacingMaterialInventoryList();
                if (isSupplierQuestionnaire) {
                    if (nextJumpIndex >= supplierLevelQuestionnaire.questionnaire?.pages?.length) {

                        if (mainInventoryList.length >= SurveyResponseController.materiaListSizeGroupThreshold) {
                            this.props.setMainNavPage(SurveyPageType.Batch);
                        } else if (mainInventoryList.length > 0) {
                            this.props.setSurveySelectedInventory(0);
                        }
                    } else {
                        this.props.setMainNavPage(SurveyPageType.SupplierQuestionnaire, this.props.navContext.surveyQuestionnaireIndex, nextJumpIndex, previousPageStack);
                    }
                }
                else if (nextJumpIndex >= this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages.length &&
                    this.props.navContext.surveyQuestionnaireIndex == this.props.surveyQuestionnairesList.length - 1 &&
                    this.props.navContext.inventoryNavIndex == mainInventoryList.length - 1 && SurveyResponseController.isOverallValid(this.props.validationResult)) {
                    return this.showModal("submit-survey-response-modal");
                }
                else if (nextJumpIndex >= this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages.length &&
                    this.props.navContext.surveyQuestionnaireIndex == this.props.surveyQuestionnairesList.length - 1) {
                    this.props.setSurveySelectedInventory(this.props.navContext.inventoryNavIndex + 1)
                } else if (nextJumpIndex >= this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages.length &&
                    this.props.navContext.surveyQuestionnaireIndex < this.props.surveyQuestionnairesList.length - 1) {
                    this.props.setNavigationContext(this.props.navContext.mainNavIndex, this.props.navContext.inventoryNavIndex, this.props.navContext.surveyQuestionnaireIndex + 1, 0, previousPageStack);
                } else {
                    this.props.setNavigationContext(this.props.navContext.mainNavIndex, this.props.navContext.inventoryNavIndex, this.props.navContext.surveyQuestionnaireIndex, nextJumpIndex, previousPageStack);
                }
            }
        }
    }

    private onResponseChange = async (
        value: string,
        valueComment: string,
        questionIndex: number,
        files?: FileTableEntry[],
        attachedFileIds?: string[]
    ): Promise<void> => {
        const supplierLevelQuestionnaire = SurveyResponseController.getSupplierLevelQuestionnaire();
        const isSupplierQuestionnaire = this.props.navContext.mainNavIndex === SurveyPageType.SupplierQuestionnaire && supplierLevelQuestionnaire;
    
        const inventoryForThisChange = this.props.selectedInventory;
        const questionnaireIndexForThisChange = this.props.navContext.surveyQuestionnaireIndex;
        const pageIndexForThisChange = this.props.navContext.surveyQuestionnairePageIndex;
        let question: QuestionnaireQuestion | null = null;
        let shouldRevalidate = false; 

        if (isSupplierQuestionnaire) {
            const page = this.props.coreData?.response?.supplierQuestionnaireData?.questionnaire?.pages[pageIndexForThisChange];
            question = page?.questions[questionIndex] ? { ...page.questions[questionIndex] } : null;

            if (!question) return;

            if (question.type === QuestionType.ImportCMRT) {
                if (page) {
                    await this.processCmrtQuestionsFromCmrtFileJson(value, page.questions, files, attachedFileIds, true);
                    shouldRevalidate = true;
                }
            } else {
                this.props.updateSupplierQuestionnaire(value, questionIndex, files, attachedFileIds);
                if (question.summaryFieldKey === "cmrt_declaration_of_scope_or_class" && value !== question.value) {
                    shouldRevalidate = true;
                }
            }
            if (shouldRevalidate) {
                await this.revalidateSurvey();
            }

            await this._supplierQuestionnaireSaveDataManager.saveAsync(supplierLevelQuestionnaire.questionnaire);

        } else if (this.props.navContext.mainNavIndex === SurveyPageType.Inventory && inventoryForThisChange !== null) {
            const page = this.props.surveyQuestionnairesList[questionnaireIndexForThisChange]?.pages[pageIndexForThisChange];
            question = page?.questions[questionIndex] ? { ...page.questions[questionIndex] } : null;
    
            if (!question) return;
    
            if (question.type === QuestionType.ImportCMRT) {
                await this.processCmrtQuestionsFromCmrtFileJson(value, page.questions, files, attachedFileIds, false);
            } else {
                this.props.updateQuestion(value, valueComment, questionIndex, files, attachedFileIds);
            }
            await this._inventoryQuestionnaireSaveDataManager.saveAsync(inventoryForThisChange);
            
            this.props.updateQuestionRequired([...this.props.surveyQuestionnairesList]);
        }
        
        await this.responseChangedHandleNavigation(question, supplierLevelQuestionnaire, value);
    };
    

    private async revalidateSurvey(){
        try {
            const invalidateResult = await this._serviceClient.invalidateSurveyResponses(this.props.responseId);
            
            if (invalidateResult.success) {
                // First save the questionnaire
                const supplierLevelQuestionnaire = SurveyResponseController.getSupplierLevelQuestionnaire();
                if (supplierLevelQuestionnaire && supplierLevelQuestionnaire.questionnaire) {
                    await this._supplierQuestionnaireSaveDataManager.saveAsync(supplierLevelQuestionnaire.questionnaire);
                    
                    if (this.props.selectedInventory) {
                        await this._serviceClient.inventorySummaryDataQuestionnaireResponseUpdate(
                            this.props.responseId,
                            this.props.selectedInventory,
                            this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]
                        );
                    }
                }
                
                const currentInventoryIds = SurveyResponseController.getMainSupplierFacingMaterialInventoryList()
                    .map(inv => inv.inventoryId);
                    
                // Finally call the existing action to update validation results
                await this.props.updateValidationResult(currentInventoryIds);
            }
        } catch (error) {
            console.error("Error during survey validation process:", error);
        }
    }
    // Private method to process questions from JSON
    private processCmrtQuestionsFromCmrtFileJson(value: string, questions: any[], files?: FileTableEntry[], attachedFileIds?: string[], isSupplierQuestionnaire: boolean = false): void {
        let index: number = 0;
        let parsedObject = JSON.parse(value);

        questions.forEach((question) => {
            const key = question.summaryFieldKey;
            if(key === "cmrt_files")
            {
                const fileId = parsedObject["cmrt_files_0"] || parsedObject[parsedObject.length - 1];
                    attachedFileIds?.push(fileId);
                if(fileId !== undefined)
                if (isSupplierQuestionnaire) {
                    this.props.updateSupplierQuestionnaire(fileId, index, files, attachedFileIds);
                } else {
                    this.props.updateQuestion(fileId, "", index, files, attachedFileIds);
                }
            }
            else if (key in parsedObject) {
                const value = parsedObject[key];
                if (isSupplierQuestionnaire) {
                    this.props.updateSupplierQuestionnaire(value, index, files, attachedFileIds);
                } else {
                    this.props.updateQuestion(value, "", index, files, attachedFileIds);
                }
            }
            index++;
        });
    }

    private saveInventoryQuestionnaire = async (inventory: InventoryDetailsResponse) => {
        if (this.props.coreData?.response.state === 1) {
            return true;
        }

        let apiResult: Result;

        const questionnaireType = this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex];

        if (questionnaireType === InventoryQuestionnaireType.BaseQuestionnaire ||
            questionnaireType.toString() === this.baseQuestionnaire) {

            apiResult = await this._serviceClient.inventorySummaryDataQuestionnaireResponseUpdate(this.props.responseId, inventory, this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]);
        }
        else {
            apiResult = await this._serviceClient.questionnaireResponseUpdate(
                this.props.responseId,
                inventory.inventoryId,
                this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] === InventoryQuestionnaireType.AttestationQuestionnaire,
                this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex],
                this.props.selectedInventory?.fileList ?? []
            );
        }

        if (this.props.selectedInventory?.inventoryId) {
            await this.props.updateValidationResult([this.props.selectedInventory?.inventoryId]);
        }

        return apiResult.success;
    }

    private saveSupplierQuestionnaire = async () => {
        if (this.props.coreData?.response.state === 1) {
            return true;
        }

        const apiResult = await this._serviceClient.questionnaireResponseUpdate(
            this.props.responseId,
            "",
            this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] === InventoryQuestionnaireType.AttestationQuestionnaire,
            this.props.coreData!.response.supplierQuestionnaireData!.questionnaire,
            this.props.coreData?.response.supplierQuestionnaireData?.files ?? []
        );

        await this.props.updateSupplierQuestionnaireValidationResult();

        return apiResult.success;
    }

    private getQuestionnaireRevisionInstructions() {
        if (this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] == InventoryQuestionnaireType.AttestationQuestionnaire) {
            return this.props.selectedInventory?.revisionRequest?.attestationQuestionnaireQuestionRevisions;
        } else if (this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] == InventoryQuestionnaireType.CustomQuestionnaire) {
            return this.props.selectedInventory?.revisionRequest?.bomQuestionnaireQuestionRevisions;
        }
    }

    private getPageRevisionInstructions() {
        if (this.props.questionnairesTypes[this.props.navContext.surveyQuestionnaireIndex] == InventoryQuestionnaireType.BaseQuestionnaire)
        {
            switch (this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.type) {
                case QuestionnairePageType.CaProp65:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.CaProp65RegulationId];
                case QuestionnairePageType.Circularity:
                    return this.props.selectedInventory?.revisionRequest?.circularityRevisionInstructions;
                case QuestionnairePageType.ConflictMinerals:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.ConflictMineralsRegulationId];
                case QuestionnairePageType.ConflictMineralsV2:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.ConflictMineralsV2RegulationId];
                case QuestionnairePageType.DynamicRegulation:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[this.props.surveyQuestionnairesList[this.props.navContext.surveyQuestionnaireIndex]?.pages[this.props.navContext.surveyQuestionnairePageIndex]?.regulationId ?? ""];
                case QuestionnairePageType.ReachAuthorisationCompliance:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.ReachSvhcAuthorizationRegulationId];
                case QuestionnairePageType.ReachAuthorisationV2Compliance:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.ReachSvhcAuthorizationV2RegulationId];
                case QuestionnairePageType.REACHCompliance:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.ReachSvhcCandidateRegulationId];
                case QuestionnairePageType.RoHSCompliance:
                    return this.props.selectedInventory?.revisionRequest?.dynamicRegulationRevisionInstructions[RegulationManager.RohsRegulationId];
                case QuestionnairePageType.Sustainability:
                case QuestionnairePageType.SustainabilityEmbodiedCarbon:
                case QuestionnairePageType.SustainabilityWaterUse:
                case QuestionnairePageType.SustainabilityAssessment:
                case QuestionnairePageType.SustainabilityOptimization:
                case QuestionnairePageType.SustainabilityTransparency:
                    return this.props.selectedInventory?.revisionRequest?.sustainabilityRevisionInstructions;
                case QuestionnairePageType.VocAll:
                case QuestionnairePageType.VocAssessment:
                case QuestionnairePageType.VocOptimization:
                case QuestionnairePageType.VocTransparency:
                    return this.props.selectedInventory?.revisionRequest?.vocRevisionInstructions;
                case QuestionnairePageType.BOM:
                    return this.props.selectedInventory?.revisionRequest?.bomQuestionnaireQuestionRevisions;
                default:
                    return null;
            }
        } else if (this.props.navContext.mainNavIndex == SurveyPageType.Bom) {
            return this.props.selectedInventory?.revisionRequest?.bomColumnRevisions;
        }
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(SurveyPage as any);
